export default __webpack_public_path__ + "static/media/IMG_116.128b7d8c.jpg";